import { Flex, Space, Tooltip } from "antd"
import { FC } from "react"
import { PAGES } from "../../../../types/pages"
import { QuestionCircleOutlined } from "@ant-design/icons"
import Link from "antd/es/typography/Link"

interface IAsinCvr {
  asinCvr: number | null
  isExact: boolean
}

const AsinCvr: FC<IAsinCvr> = ({ asinCvr, isExact }) => {
  if (!isExact) {
    return (
      <Tooltip
        title={
          <Flex vertical align="flex-end">
            This data is only available for &quot;Exact&quot; campaigns.
          </Flex>
        }
      >
        <Space>
          <QuestionCircleOutlined />
          No Data
        </Space>
      </Tooltip>
    )
  }

  if (asinCvr) {
    return <div>{asinCvr} %</div>
  }

  return (
    <Tooltip
      title={
        <Flex vertical align="flex-end">
          To see this value, add a campaign to the project.
          {<Link href={PAGES["Projects"]}>Projects</Link>}
        </Flex>
      }
    >
      <Space>
        <QuestionCircleOutlined />
        No Data
      </Space>
    </Tooltip>
  )
}

export default AsinCvr
